<div class="center main-width" [hidden]="!isReady">

   <vision-header></vision-header>
   <vision-progress></vision-progress>

   <div class="vision">
      <nav  class="SkipToNav" role="navigation">
            <h2 class="OffScreen-Text">Start of Ontario.ca skip to page section links</h2>
            <ul>
                <!--<li><a href="#" role="button" (click)="scrollTo('btn-next')">Skip to content</a></li>-->
                <li><a id="skipNav" href="#" role="button" (click)="scrollTo('footer', $event)">Skip to footer</a></li>
      
                <!--<li><a href="#errors">Skip to first error</a></li>-->
                
            </ul>
         </nav>
   </div>   
      
    <light-box margin="8/0" outer-class="session-out31">
          <notice-box outer-class="session-out30">
                <header-x (close)="onContinue()" title="{{'timer.x_button_alt' | translate}}"></header-x>

                <div style="padding-top:1.8em; padding-left:1em" translate='timer.page_title'></div>

                <div class="btn-div">
                  <button (click)="onExit()"  class='btn-session' translate='timer.end_button'></button>
                  <button (click)="onContinue()"  class='btn-session' translate='timer.continue_button'></button>
                </div>
          </notice-box>
    </light-box>  


   <router-outlet></router-outlet>

   <div [hidden]="!isLoading && !timerService.isForwarding" style="vertical-align:middle; margin-top:8em; height:12em;">

        <div class="btn-div">
            <img src="refresh/assets/images/ChasingArrows.gif">
        </div>

   </div>
   <vision-footer></vision-footer>
</div>

